/**
 * Console build/release identifier for the `app_version` property (RFC-0974
 * app-health follow-up, spec §4).
 *
 * Every app-health event carries `app_version` for release-over-release slicing.
 * The source of truth is the same constant the version-check hook and the build
 * badge read — `import.meta.env.VITE_APP_BUILD_VERSION`, baked at build time from
 * the deploy SHA/release id. We normalize (trim + length-bound) and fall back to
 * `'unknown'` so the field is ALWAYS a non-empty string (the collector drops
 * empty/nonprimitive values, and a missing app_version would break the slicing).
 */

const MAX_LEN = 64

/** Normalized console build/release id, or `'unknown'` when unset/invalid. */
export function getAppVersion(): string {
  try {
    const raw = import.meta.env.VITE_APP_BUILD_VERSION
    if (typeof raw === 'string') {
      const trimmed = raw.trim()
      if (trimmed && trimmed.length <= MAX_LEN) return trimmed
      if (trimmed) return trimmed.slice(0, MAX_LEN)
    }
  } catch {
    /* fall through to the fallback */
  }
  return 'unknown'
}
